import {
    Box,
    Button,
    Flex,
    IconButton,
    Table,
    TableContainer,
    Tag,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    Input,
    useToast,
    Switch,
    Image,
    useBreakpointValue,
    Grid,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverBody,
    VStack,
} from "@chakra-ui/react";
import CommonModal from "components/common/CommonModal/CommonModal";
import { Paginationlimit } from "components/common/functions/variable";
import Pagination from "components/common/Pagination/Pagination";
import TableLoader from "components/common/TableLoader/TableLoader";
import React, { useEffect, useState } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { appRequest } from "routes";
import { EditIcon } from "@chakra-ui/icons";
import { useHasPermission } from "../common/PermissionsFunction/permissiosnFunction";
import CreateAd from "./CreateAd/CreateAd";
import { IoImage } from "react-icons/io5";
import AdCard from "./AdCardView/AdCard";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";
import debounce from "lodash.debounce";

export default function AdsTable(): JSX.Element {
    const initialDateRange = {
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
        key: "selection",
    };

    const [dateRange, setDateRange] = useState<any>(initialDateRange);
    const { startDate, endDate } = dateRange;
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [data, setData] = useState<any[]>([]);
    const [editData, setEditData] = useState({});
    const [editingIndex, setEditingIndex] = useState(-1);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [selectedAdPath, setSelectedAdPath] = useState<string>("");
    const [searchQuery, setSearchQuery] = useState(""); // New state for search query
    const toast = useToast();

    const isMobileView = useBreakpointValue({ base: true, md: false });

    const getAds = async () => {
        try {
            setLoading(true);
            let page = currentPage;
            let limit = Paginationlimit;
            const request: any = {
                limit,
                page,
                ...(searchQuery.trim() && { search: searchQuery.trim() }),
            };
            const response: any = await appRequest("ads", "getAllAds", request);

            if (response.status === "success") {
                console.log("get all ads response", response)
                setTotalPages(response?.totalPages || 0);
                setData(response?.ads || []);
            }
        } catch (error: any) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAds();
    }, [currentPage, searchQuery]);

    const handleSearch = debounce((query: string) => {
        setSearchQuery(query);
        setCurrentPage(1); // Reset to the first page when searching
    }, 300); // Debounce for 300ms

    const handlePageChange = (page: any) => {
        setCurrentPage(page.selected + 1);
    };

    const handleEdit = (item: any) => {
        setEditData(item);
        setIsCreateModalOpen(true);
    };

    const handleRefreshAllData = () => {
        setDateRange(initialDateRange);
        setSearchQuery(""); // Clear search query
        getAds();
    };

    return (
        <>
            <Box
                p={5}
                rounded={"lg"}
                bg={"white"}
                shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
            >
                <Flex
                    justify={"space-between"}
                    mb={2}
                    direction={{ base: "column", md: "row" }}
                >
                    <Text fontWeight={700} fontSize={"xl"} color={"teal.400"} mb={2}>
                        All Ads
                    </Text>

                    <Flex gap={2} justify={"end"} direction={{ base: "column", md: "row" }}>
                        <SearchBox onSearch={handleSearch} />

                        <Grid templateColumns="1fr 1fr" gap={2} alignItems={'center'}>
                            <Button
                                onClick={() => {
                                    setIsCreateModalOpen(true);
                                }}
                                colorScheme="teal"
                                size={{ base: "sm", md: "md" }}
                            >
                                ADD
                            </Button>
                            <Tooltip label="Refresh" hasArrow>
                                <IconButton
                                    aria-label="Refresh"
                                    icon={<HiOutlineRefresh />}
                                    colorScheme="teal"
                                    variant="outline"
                                    borderWidth={2}
                                    _hover={{ bg: "teal.100" }}
                                    onClick={handleRefreshAllData}
                                    size={{ base: "sm", md: "md" }}
                                />
                            </Tooltip>
                        </Grid>
                    </Flex>
                    {/* </Flex> */}
                </Flex>

                {isMobileView ? (
                    <AdCard data={data} setIsImageModalOpen={setIsImageModalOpen} setSelectedAdPath={setSelectedAdPath} handleEdit={handleEdit} />
                ) : (
                    <>

                        <TableContainer className="customScrollBar" pb={2}>
                            <Table>
                                <Thead>
                                    <Tr>
                                        <Th>Name</Th>
                                        <Th>Redirect Url</Th>
                                        <Th>Is Active</Th>
                                        <Th>Image</Th>
                                        <Th></Th>
                                    </Tr>
                                </Thead>
                                <TableLoader
                                    noDataText="No Cities  Available"
                                    show={data?.length}
                                    loader={loading}
                                >
                                    <Tbody>
                                        {data?.map((ad, index) => (
                                            <Tr
                                                key={ad._id}
                                                _hover={{ bg: "gray.100" }}
                                                className={JSON.stringify(index)}
                                                cursor={"default"}
                                            // onClick={() => {
                                            //     handleRowClick(ad._id);
                                            // }}
                                            >
                                                <Td
                                                // onClick={(e) => {
                                                //     if (editingIndex !== index) {
                                                //     } else {
                                                //         e.stopPropagation();
                                                //     }
                                                // }}
                                                // cursor={editingIndex !== index ? "pointer" : "default"}
                                                >
                                                    <Text fontWeight={500}>{ad.name || "N/A"}</Text>
                                                </Td>
                                                <Td>
                                                    <Text isTruncated maxW={"10rem"}>
                                                        {ad.redirect_url || "N/A"}
                                                    </Text>
                                                </Td>
                                                <Td>
                                                    <Tag
                                                        size="sm"
                                                        colorScheme={ad.is_active ? "green" : "red"}
                                                    >
                                                        {ad.is_active ? "Yes" : "No"}
                                                    </Tag>
                                                </Td>
                                                <Td>
                                                    <IconButton
                                                        size={"sm"}
                                                        colorScheme="teal"
                                                        variant={"outline"}
                                                        aria-label="Image"
                                                        icon={<IoImage />}
                                                        onClick={() => {
                                                            setSelectedAdPath(ad.path);
                                                            setIsImageModalOpen(true);
                                                        }}
                                                    />
                                                </Td>
                                                <Td display={"flex"} gap={6}>
                                                    <Tooltip label="Edit" hasArrow>
                                                        <IconButton
                                                            size={"sm"}
                                                            colorScheme="teal"
                                                            variant={"outline"}
                                                            aria-label="Edit"
                                                            icon={<EditIcon />}
                                                            onClick={() => handleEdit(ad)}
                                                        />
                                                    </Tooltip>
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </TableLoader>
                            </Table>
                        </TableContainer>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            handlePageChange={handlePageChange}
                        />
                    </>
                )}
                <CommonModal
                    header={editingIndex >= 0 ? "Edit Ad" : "Add Ad"}
                    width={{ base: "100vw", md: "60vw" }}
                    animate={true}
                    isOpen={isCreateModalOpen}
                    onClose={() => {
                        setIsCreateModalOpen(false);
                        setEditData({});
                        setEditingIndex(-1);
                    }}
                    body={
                        <Box>
                            <CreateAd
                                setIsCreateModalOpen={setIsCreateModalOpen}
                                handleRefreshAllData={handleRefreshAllData}
                                initialData={editData} // Pass editData here
                            />
                        </Box>
                    }
                />

            </Box>
            <CommonModal
                isOpen={isImageModalOpen}
                onClose={() => {
                    setIsImageModalOpen(false);
                }}
                isCentered={true}
                size="md"
                closeOnOverlayClick={true}
                body={
                    <Box p={{ base: 0, md: 4 }} mt={{ base: 2, md: 0 }}>
                        <Image
                            src={selectedAdPath}
                            alt="Ad Image"
                            borderRadius="lg"
                            maxW="100%"
                            maxH="400px"
                            objectFit="contain"
                        />
                    </Box>
                }
            />
        </>
    );
}
